type WithEvent<T extends { event?: unknown }> = T & {
  event: NonNullable<T["event"]>;
};

const hasEvent = <T extends { event?: unknown }>(
  occurrence: T
): occurrence is WithEvent<T> => occurrence.event != null;

export default hasEvent;
